<template>
    <div>
        <van-cell-group title="请填写家人信息" name="1">
            <van-field v-model="form.memberName" placeholder="请输入Ta的姓名" label="姓名" />
        </van-cell-group>
        <van-cell-group name="2">
            <van-field class="relation" v-model="form.userRelation" placeholder="请选择Ta与您的关系" label="关系" right-icon="arrow-down" disabled @click="showPicker = true"/>
        </van-cell-group>
        <van-cell-group name="5">
            <van-field v-model="form.memberIdCardType"  placeholder="请选择证件类型" label="证件类型" right-icon="arrow-down"  disabled @click="showIdCardType = true"/>
        </van-cell-group>
        <van-cell-group name="3">
            <van-field v-model="form.memberIdCard" placeholder="请输入Ta的身份证" label="身份证号" />
        </van-cell-group>
        <van-cell-group name="4">
            <van-field v-model="form.memberPhone" type="number" placeholder="请输入Ta的手机号码" label="联系方式" />
        </van-cell-group>
        <van-cell-group name="6">
             <van-field v-model="form.memberContacts"  placeholder="请输入联系人" label="联系人名称" />
        </van-cell-group>
         <van-cell-group name="7">
             <van-field v-model="form.memberGender"  placeholder="请选择性别" label="性别" right-icon="arrow-down"  disabled @click="showGender = true"/>
         </van-cell-group>
         <van-cell-group name="8">
              <van-field v-model="form.memberBirthdate"  placeholder="请输入生日" label="生日" disabled @click="show = true" />
         </van-cell-group>
        <div style="margin-top: 16px; text-align: center; text-decoration:underline; color: #999999; font-size: 12px;" @click="deleteInfo">删除</div>
        <van-button round type="info" color="linear-gradient(to right, #4587DD, #40B6F8)"
                    style="position: fixed; bottom: 20px; left: 10%; right: 10%; width: 80%;"
                    @click="add">提交信息
        </van-button>

        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" @change="onChange"/>
        </van-popup>
        <van-popup v-model="showIdCardType" position="bottom">
            <van-picker show-toolbar :columns="idCartType" @cancel="showPicker = false" @confirm="onConfirmIdCardType" @change="onChangeIdCardType"/>
        </van-popup>
        <van-popup v-model="showGender" position="bottom">
            <van-picker show-toolbar :columns="gender" @cancel="showPicker = false" @confirm="onConfirmGender" @change="onChangeGender"/>
        </van-popup>
        <van-popup v-model="show" position="bottom">
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="show = false"
                @confirm="onConfirmBirth"
                @change="onChangeBirth"
            />
        </van-popup>
    </div>
</template>

<script>

    import Vue from 'vue';
    import { Field, Cell, CellGroup, Popup, Picker, Dialog, Notify } from 'vant';

    Vue.use(Field).use(Cell).use(CellGroup).use(Popup).use(Picker).use(Dialog).use(Notify);

    export default {
        name: "FamilyDetail",
        data() {
            return {
                id: this.$route.query.id,
                form: {},
                showPicker: false,
                showGender: false,
                show: false,
                showIdCardType: false,
                columns: ['父亲','母亲','夫妻','儿女','兄弟姐妹','自己','其他'],
                idCartType:['居民身份证','香港居民身份证','台胞证','护照','组织机构代码','军官退休证','军官证','澳门居民身份证','税务登记证','统一社会信用代码'],
                gender:['男','女'],
                minDate: new Date(1900, 0, 1),
                maxDate: new Date(2050, 10, 1),
                currentDate: new Date()
            }
        },
        created() {
            this.$axios.get("/member/info", {
                params: {memberId : this.id},
            }).then(res => {
                this.form = res.data
                switch(this.form.memberIdCardType){
                    case "106":this.form.memberIdCardType = "香港居民身份证";break;
                    case "105":this.form.memberIdCardType = "台胞证";break;
                    case "104":this.form.memberIdCardType = "护照";break;
                    case "108":this.form.memberIdCardType = "组织机构代码";break;
                    case "103":this.form.memberIdCardType = "军官退休证";break;
                    case "102":this.form.memberIdCardType = "军官证";break;
                    case "101":this.form.memberIdCardType = "居民身份证";break;
                    case "107":this.form.memberIdCardType = "澳门居民身份证";break;
                    case "109":this.form.memberIdCardType = "税务登记证";break;
                    case "110":this.form.memberIdCardType = "统一社会信用代码";break;
                }
                switch(this.form.memberGender){
                    case "M":this.form.memberGender = "男";break;
                    case "F":this.form.memberGender = "女";break;
                }
            })
        },
        methods: {
            onChange(picker, value, index){
                this.$set(this.form,'userRelation', value)
            },
            onConfirm(value, index){
                this.showPicker = false
                this.form.userRelation = value
            },
            onChangeIdCardType(picker, value, index){
                this.$set(this.form,'memberIdCardType', value)
            },
            onConfirmIdCardType(value, index){
                this.showIdCardType = false
                this.form.memberIdCardType = value
            },
            onChangeGender(picker, value, index){
                this.$set(this.form,'memberGender', value)
            },
            onConfirmGender(value, index){
                this.showGender = false
                this.form.memberGender = value
            },
            onChangeBirth(picker, value, index){
                this.$set(this.form,'memberBirthdate', value)
            },
            onConfirmBirth(value, index){
                this.show = false
                var date = value;
                var m = date.getMonth() + 1;
                var d = date.getDate();
                if (m >= 1 && m <= 9) {
                    m = "0" + m;
                }
                if (d >= 0 && d <= 9) {
                    d = "0" + d;
                }
                var timer = date.getFullYear() + "-" + m + "-" + d
                this.form.memberBirthdate = timer
            },
            add() {
                if (this.checkInValid()) { //检测信息是否合法
                    return;
                }
                switch(this.form.memberIdCardType){
                    case "香港居民身份证":this.form.memberIdCardType = "106";break;
                    case "台胞证":this.form.memberIdCardType = "105";break;
                    case "护照":this.form.memberIdCardType = "104";break;
                    case "组织机构代码":this.form.memberIdCardType = "108";break;
                    case "军官退休证":this.form.memberIdCardType = "103";break;
                    case "军官证":this.form.memberIdCardType = "102";break;
                    case "居民身份证":this.form.memberIdCardType = "101";break;
                    case "澳门居民身份证":this.form.memberIdCardType = "107";break;
                    case "税务登记证":this.form.memberIdCardType = "109";break;
                    case "统一社会信用代码":this.form.memberIdCardType = "110";break;
                }
                switch(this.form.memberGender){
                    case "男":this.form.memberGender = "M";break;
                    case "女":this.form.memberGender = "F";break;
                }
                this.$axios.post("/member/profile ", this.form).then(res => {
                    if (res.code == 200) {
                        this.$router.back()
                    }
                });
            },
            checkInValid() {
                if (this.form.memberName.length === 0) {
                    Notify({
                        message: '请填写姓名',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return true;
                }
                if (this.form.userRelation.length === 0) {
                    Notify({
                        message: '请选择关系',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return true;
                }
                 if (this.form.memberIdCardType.length === 0) {
                    Notify({
                        message: '请选择证件类型',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return true;
                }
                if (this.form.memberIdCard.length === 0) {
                    Notify({
                        message: '请填写身份证',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return true;
                }
                if (this.form.memberPhone.length === 0) {
                    Notify({
                        message: '请填写手机号码',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return true;
                }

                if (this.form.memberContacts.length === 0) {
                  Notify({
                      message: '请填写联系人名称',
                      duration: 2500,
                      background: '#F76C6C'
                  });
                  return true;
                }
                if (this.form.memberGender.length === 0) {
                   Notify({
                       message: '请选择性别',
                       duration: 2500,
                       background: '#F76C6C'
                   });
                   return true;
                }
               if (this.form.memberBirthdate.length === 0) {
                    Notify({
                        message: '请输入生日',
                        duration: 2500,
                        background: '#F76C6C'
                    });
                    return true;
                }
                return false;
            },
            deleteInfo() {
                Dialog.confirm({
                    message: '确定删除吗？'
                }).then(() => {
                    this.$axios.get("/member/remove", {
                        params: {memberId : this.id},
                    }).then(res => {
                        this.$router.back()
                    })
                }).catch(() => {
                    // on cancel
                });
            }
        }

    }
</script>

<style scoped>

</style>
